import React from 'react';

import API from 'api';
import COVID19SettingsContainer from '../../covid19/COVID19SettingsContainer';

type Covid19SettingsProps = {
  listingId: string;
};

const Covid19Settings = ({ listingId }: Covid19SettingsProps) => (
    <>
      <COVID19SettingsContainer
        getCovid19OrgSettings={async () =>
          API.GET.getCovid19ListingSettings(listingId)
        }
        saveCovid19OrgSettings={async newSettings =>
          API.POST.saveCovid19ListingSettings(newSettings, listingId)
        }
      />
    </>
  );
export default Covid19Settings;
